(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards-shero-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SECTION_SELECTOR = '[data-cards-shero]';
    var DESC_SELECTOR = '[data-hero-shero-desc]';
    var TITLE_SELECTOR = '[data-hero-shero-title]';
    var INIT_FLAG = 'cardsSheroInit';

    function initSection(section) {
      if (!section || section.dataset[INIT_FLAG] === '1') return;
      section.dataset[INIT_FLAG] = '1';

      /* ── Grid: show cards immediately (scroll-reveal was unreliable when IO never fired) ── */
      var cells = section.querySelectorAll('.cards-shero__cell');
      Array.prototype.forEach.call(cells, function (el) {
        el.classList.add('is-visible');
      });

      /* Mobile: render title/desc statically — skip SplitText entirely.
         SplitText accounts for ~600ms of forced reflow on mobile per Lighthouse. */
      var isMobile = window.matchMedia('(max-width: 989px)').matches;
      if (isMobile) {
        var titleEl = section.querySelector(TITLE_SELECTOR);
        var descEl = section.querySelector(DESC_SELECTOR);
        if (titleEl) { titleEl.style.opacity = '1'; titleEl.style.transform = 'none'; }
        if (descEl) { descEl.style.opacity = '1'; descEl.style.transform = 'none'; }
        return;
      }

      /* ── Heading / Subheading animations (GSAP + SplitText) ──
         Deferred past LCP: SplitText forces layout to measure line breaks,
         which shows up as a ~180ms forced reflow during critical render. */
      function runHeroTextAnim() {
      if (typeof gsap !== 'undefined') {
        var title = section.querySelector(TITLE_SELECTOR);
        var desc = section.querySelector(DESC_SELECTOR);

        var hasSplit = typeof SplitText !== 'undefined';
        var descSplit = null;
        var titleSplit = null;

        if (hasSplit) {
          try {
            gsap.registerPlugin(SplitText);
          } catch (e) {
            hasSplit = false;
          }
        }

        if (title) {
          gsap.set(title, { opacity: 1, y: 0 });

          if (hasSplit) {
            try {
              titleSplit = SplitText.create(title, {
                type: 'lines,words,chars',
                linesClass: 'cards-shero__title-line',
                wordsClass: 'cards-shero__title-word',
                charsClass: 'cards-shero__title-char',
                autoSplit: true,
                mask: 'lines',
              });

              if (titleSplit.lines && titleSplit.lines.length) {
                gsap.set(titleSplit.lines, { overflow: 'hidden' });
              }

              if (titleSplit.chars && titleSplit.chars.length) {
                gsap.set(titleSplit.chars, {
                  yPercent: 120,
                });
              }
            } catch (e) {
              titleSplit = null;
            }
          }
        }

        if (desc && hasSplit) {
          try {
            descSplit = SplitText.create(desc, {
              type: 'lines,words,chars',
              linesClass: 'cards-shero__desc-line',
              charsClass: 'cards-shero__desc-char',
              autoSplit: true,
              mask: 'lines',
            });

            if (descSplit.chars && descSplit.chars.length) {
              gsap.set(descSplit.chars, {
                yPercent: 110,
                opacity: 0,
              });
            }
          } catch (e) {
            descSplit = null;
          }
        }

        if (!hasSplit && desc) {
          gsap.set(desc, { opacity: 0, y: 20 });
        }

        function runDescAnimation() {
          if (!desc) return;
          if (hasSplit && descSplit && descSplit.chars && descSplit.chars.length) {
            if (descSplit.lines && descSplit.lines.length) {
              descSplit.lines.forEach(function (line) {
                line.style.overflow = 'hidden';
              });
            }
            var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
            tl.to(descSplit.chars, {
              opacity: 1,
              yPercent: 0,
              rotateX: 0,
              duration: 0.8,
              stagger: { each: 0.02, from: 'start' },
            });
          } else {
            gsap.to(desc, {
              opacity: 1,
              y: 0,
              duration: 0.6,
              ease: 'power3.out',
            });
          }
        }

        function runTitleAnimation() {
          if (!title) return;
          var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
          if (titleSplit && titleSplit.chars && titleSplit.chars.length) {
            tl.to(titleSplit.chars, {
              yPercent: 0,
              duration: 0.9,
              stagger: { each: 0.025, from: 'start' },
            });
          } else {
            tl.fromTo(
              title,
              { opacity: 0, y: 40 },
              { opacity: 1, y: 0, duration: 0.9 }
            );
          }
        }

        runTitleAnimation();

        if (desc) {
          if (typeof IntersectionObserver !== 'undefined') {
            var descObserver = new IntersectionObserver(
              function (entries, obs) {
                entries.forEach(function (entry) {
                  if (!entry.isIntersecting) return;
                  obs.unobserve(entry.target);
                  runDescAnimation();
                });
              },
              { threshold: 0.35 }
            );
            descObserver.observe(desc);
          } else {
            runDescAnimation();
          }
        }
      }

      }
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(runHeroTextAnim, { timeout: 1500 });
      } else {
        setTimeout(runHeroTextAnim, 200);
      }

      /* ── Grid: Parallax on hover (desktop only) ── */
      if (!('ontouchstart' in window)) {
        Array.prototype.forEach.call(cells, function (cell) {
          var img = cell.querySelector('.cards-shero__cell-img');
          if (!img) return;
          var rafId = 0;
          cell.addEventListener('mousemove', function (e) {
            if (rafId) return;
            rafId = requestAnimationFrame(function () {
              rafId = 0;
              var r = cell.getBoundingClientRect();
              var x = ((e.clientX - r.left) / r.width - 0.5) * 12;
              var y = ((e.clientY - r.top) / r.height - 0.5) * 12;
              img.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(1.12)';
            });
          });
          cell.addEventListener('mouseleave', function () {
            img.style.transform = 'scale(1.05)';
          });
        });
      }

      /* ── Touch: tap to reveal logo + arrow (mobile) ── */
      if ('ontouchstart' in window) {
        Array.prototype.forEach.call(cells, function (cell) {
          cell.addEventListener('touchstart', function () {
            cell.classList.add('is-touched');
          }, { passive: true });
          cell.addEventListener('touchend', function () {
            setTimeout(function () {
              cell.classList.remove('is-touched');
            }, 1500);
          }, { passive: true });
        });
      }

      /* autoplay removed — moved to inline <script> */
    }

    function initAll(root) {
      var container = root && root.querySelectorAll ? root : document;
      var sections = container.querySelectorAll
        ? container.querySelectorAll(SECTION_SELECTOR)
        : [];
      Array.prototype.forEach.call(sections, initSection);
    }

    function boot() {
      initAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var container = e.target;
      var sections = container.querySelectorAll
        ? container.querySelectorAll(SECTION_SELECTOR)
        : [];
      Array.prototype.forEach.call(sections, function (section) {
        delete section.dataset[INIT_FLAG];
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-with-rich-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.richContentCardInit) return;
    window.richContentCardInit = true;
    const desktop = window.matchMedia('(min-width: 750px)');
    let uid = 0;

    const cardsIn = (list) => [...list.children].filter((el) => el.classList.contains('rich-content-card'));

    const sync = (card) => {
      const trigger = card.querySelector('.rich-content-card__trigger');
      if (!trigger) return;
      // Soft cards are always open (slider on mobile), like every card on desktop
      const fixed = desktop.matches || card.parentElement.classList.contains('cards-rc__list--card');
      const open = fixed || card.dataset.open === 'true';
      trigger.setAttribute('aria-expanded', String(open));
      if (fixed) {
        trigger.setAttribute('tabindex', '-1');
      } else {
        trigger.removeAttribute('tabindex');
      }
    };

    const setOpen = (card, open) => {
      card.dataset.open = String(open);
      sync(card);
    };

    const init = (root = document) => {
      const lists = new Set();
      root.querySelectorAll('.rich-content-card').forEach((card) => lists.add(card.parentElement));
      lists.forEach((list) => {
        cardsIn(list).forEach((card, index) => {
          if (card.dataset.ready) return sync(card);
          const trigger = card.querySelector('.rich-content-card__trigger');
          const panel = card.querySelector('.rich-content-card__panel');
          uid += 1;
          panel.id = `rich-content-card-panel-${uid}`;
          trigger.setAttribute('aria-controls', panel.id);
          card.dataset.open = String(index === 0);
          card.dataset.ready = 'true';
          sync(card);
        });
      });
    };

    const open = (card) => {
      cardsIn(card.parentElement).forEach((sibling) => {
        if (sibling !== card && sibling.dataset.open === 'true') setOpen(sibling, false);
      });
      setOpen(card, true);
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.rich-content-card__trigger');
      if (!trigger || desktop.matches) return;
      const card = trigger.closest('.rich-content-card');
      if (card.dataset.open === 'true') {
        setOpen(card, false);
      } else {
        open(card);
      }
    });

    desktop.addEventListener('change', () => document.querySelectorAll('.rich-content-card').forEach(sync));
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest?.('.rich-content-card') ?? event.target.querySelector?.('.rich-content-card');
      if (card && !desktop.matches) open(card);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-with-rich-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hydrated = (el) => Object.keys(el).some((key) => key.startsWith('__reactFiber'));
    const watch = (card) => {
      if (card.dataset.formRcInit) return;
      card.dataset.formRcInit = 'true';
      const assurances = card.querySelector('.form-rc__assurances');
      if (!assurances) return;
      let pending = false;
      const place = () => {
        const buttons = card.querySelector('.hsfc-NavigationRow__Buttons');
        if (!buttons || pending || assurances.nextElementSibling === buttons) return;
        pending = true;
        const start = performance.now();
        const tryMove = () => {
          if (!buttons.isConnected) {
            pending = false;
            return;
          }
          if (hydrated(buttons) || performance.now() - start > 5000) {
            requestAnimationFrame(() => {
              pending = false;
              if (buttons.isConnected) buttons.before(assurances);
            });
          } else {
            requestAnimationFrame(tryMove);
          }
        };
        tryMove();
      };
      place();
      new MutationObserver(place).observe(card, { childList: true, subtree: true });
    };
    const init = () => document.querySelectorAll('.form-rc__card').forEach(watch);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-with-rich-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.galleryRcInit) return;
    window.galleryRcInit = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const list = root.querySelector('.gallery-rc__list');
      const dots = [...root.querySelectorAll('.gallery-rc__dot')];
      const current = root.querySelector('[data-current]');
      const next = root.querySelector('.gallery-rc__next');
      const prev = root.querySelector('.gallery-rc__prev');
      if (!list || !dots.length) return;
      const cards = () => [...list.children];

      const first = () => {
        const start = list.getBoundingClientRect().left + parseFloat(getComputedStyle(list).paddingLeft);
        let best = 0;
        cards().forEach((card, i) => {
          if (Math.abs(card.getBoundingClientRect().left - start) < Math.abs(cards()[best].getBoundingClientRect().left - start)) best = i;
        });
        return best;
      };

      const lastVisible = () => {
        const end = list.getBoundingClientRect().right - parseFloat(getComputedStyle(list).paddingRight);
        const from = first();
        let last = from;
        cards().forEach((card, i) => {
          if (i >= from && card.getBoundingClientRect().right <= end + 1) last = i;
        });
        return last;
      };

      const update = () => {
        const from = first();
        const to = lastVisible();
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-visible', i >= from && i <= to);
          dot.setAttribute('aria-current', String(i === from));
        });
        if (current) current.textContent = String(to + 1).padStart(2, '0');
        if (prev) prev.disabled = list.scrollLeft <= 2;
      };

      const go = (i) => {
        const card = cards()[i];
        if (!card) return;
        const left = card.offsetLeft - list.offsetLeft - parseFloat(getComputedStyle(list).paddingLeft);
        list.scrollTo({ left, behavior: reduce.matches ? 'auto' : 'smooth' });
      };

      let frame = 0;
      list.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, { passive: true });
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
      if (next) next.addEventListener('click', () => go(lastVisible() >= cards().length - 1 ? 0 : first() + 1));
      if (prev) prev.addEventListener('click', () => go(Math.max(first() - 1, 0)));
      update();
    };

    const init = () => document.querySelectorAll('[data-gallery-rc]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest?.('.gallery-rc__card');
      const root = card?.closest('[data-gallery-rc]');
      if (!root) return;
      const list = root.querySelector('.gallery-rc__list');
      list.scrollTo({ left: card.offsetLeft - list.offsetLeft - parseFloat(getComputedStyle(list).paddingLeft) });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-shero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SECTION_SELECTOR = '[data-hero-shero]';
    var DESC_SELECTOR = '[data-hero-shero-desc]';
    var TITLE_SELECTOR = '[data-hero-shero-title]';
    var INIT_FLAG = 'heroSheroInit';

    /**
     * Wait until GSAP is available, then run the callback.
     * @param {() => void} cb
     */
    function waitForGsap(cb) {
      if (typeof gsap !== 'undefined') {
        cb();
      } else {
        requestAnimationFrame(function () {
          waitForGsap(cb);
        });
      }
    }

    /**
     * Initialize GSAP SplitText animation for hero description.
     * Splits into lines, words, and chars when SplitText is available.
     * @param {HTMLElement} section
     */
    function initSection(section) {
      if (!section || section.dataset[INIT_FLAG] === '1') return;
      section.dataset[INIT_FLAG] = '1';

      if (typeof gsap === 'undefined') return;

      var title = section.querySelector(TITLE_SELECTOR);
      var desc = section.querySelector(DESC_SELECTOR);
      if (!title && !desc) return;

      var hasSplit = typeof SplitText !== 'undefined';
      var descSplit = null;
      var titleSplit = null;

      if (hasSplit) {
        try {
          // @ts-ignore
          gsap.registerPlugin(SplitText);
        } catch (e) {
          hasSplit = false;
        }
      }

      // --- Title: SplitText with nested tags/emoji support ---
      if (title) {
        // Ensure title is visible initially
        // @ts-ignore
        gsap.set(title, { opacity: 1, y: 0 });

        if (hasSplit) {
          try {
            // Support nested tags and emoji-safe splitting
            // @ts-ignore
            titleSplit = SplitText.create(title, {
              type: 'lines,words,chars',
              linesClass: 'hero-shero__title-line',
              wordsClass: 'hero-shero__title-word',
              charsClass: 'hero-shero__title-char',
              autoSplit: true,
              mask: 'lines',
            });

            if (titleSplit.lines && titleSplit.lines.length) {
              // @ts-ignore
              gsap.set(titleSplit.lines, {
                overflow: 'hidden',
              });
            }

            if (titleSplit.chars && titleSplit.chars.length) {
              // @ts-ignore
              gsap.set(titleSplit.chars, {
                yPercent: 120,
                opacity: 0,
                willChange: 'transform, opacity',
              });
            }
          } catch (e) {
            titleSplit = null;
          }
        }
      }

      // --- Desc: SplitText ---
      if (desc && hasSplit) {
        try {
          // @ts-ignore
          descSplit = SplitText.create(desc, {
            type: 'lines,words,chars',
            linesClass: 'hero-shero__desc-line',
            charsClass: 'hero-shero__desc-char',
            autoSplit: true,
            mask: 'lines',
          });

          if (descSplit.chars && descSplit.chars.length) {
            // @ts-ignore
            gsap.set(descSplit.chars, {
              yPercent: 110,
              opacity: 0,
              willChange: 'transform, opacity',
            });
          }
        } catch (e) {
          descSplit = null;
        }
      }

      if (!hasSplit && desc) {
        // @ts-ignore
        gsap.set(desc, { opacity: 0, y: 20 });
      }

      function runDescAnimation() {
        if (!desc) return;

        if (hasSplit && descSplit && descSplit.chars && descSplit.chars.length) {
          // Ensure each line wraps its contents cleanly
          if (descSplit.lines && descSplit.lines.length) {
            descSplit.lines.forEach(function (line) {
              line.style.overflow = 'hidden';
            });
          }

          // @ts-ignore
          var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
          tl.to(descSplit.chars, {
            opacity: 1,
            yPercent: 0,
            rotateX: 0,
            duration: 0.8,
            stagger: { each: 0.02, from: 'start' },
          });
        } else {
          // @ts-ignore
          gsap.to(desc, {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: 'power3.out',
          });
        }
      }

      function runTitleAnimation() {
        if (!title) return;

        // @ts-ignore
        var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

        if (titleSplit && titleSplit.chars && titleSplit.chars.length) {
          // Reveal letters one-by-one with the same rise/fade motion.
          tl.to(titleSplit.chars, {
            yPercent: 0,
            opacity: 1,
            duration: 0.9,
            stagger: { each: 0.025, from: 'start' },
          });
        } else {
          // Fallback: simple rise + fade
          // @ts-ignore
          tl.fromTo(
            title,
            { opacity: 0, y: 40 },
            { opacity: 1, y: 0, duration: 0.9 }
          );
        }

      }

      // Fire title animation once on load/section init
      runTitleAnimation();

      if (desc) {
        if (typeof IntersectionObserver !== 'undefined') {
          var observer = new IntersectionObserver(
            function (entries, obs) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                obs.unobserve(entry.target);
                runDescAnimation();
              });
            },
            { threshold: 0.35 }
          );

          observer.observe(desc);
        } else {
          runDescAnimation();
        }
      }
    }

    function initAll(root) {
      var container = root && root.querySelectorAll ? root : document;
      var sections = container.querySelectorAll
        ? container.querySelectorAll(SECTION_SELECTOR)
        : [];
      Array.prototype.forEach.call(sections, initSection);
    }

    document.addEventListener('DOMContentLoaded', function () {
      waitForGsap(function () {
        initAll(document);
      });
    });

    document.addEventListener('shopify:section:load', function (e) {
      waitForGsap(function () {
        initAll(e.target);
      });
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var container = e.target;
      var sections = container.querySelectorAll
        ? container.querySelectorAll(SECTION_SELECTOR)
        : [];
      Array.prototype.forEach.call(sections, function (section) {
        delete section.dataset[INIT_FLAG];
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps-with-rich-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.stepsRcInit) return;
    window.stepsRcInit = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 990px)');
    const clamp = (value) => Math.min(1, Math.max(0, value));
    let roots = [];
    let frame = 0;

    const layout = (root) => {
      const steps = [...root.querySelectorAll('.steps-rc__step')];
      const on = root.dataset.scroll === 'fill' && steps.length > 1 && !reduce.matches;
      root.classList.toggle('steps-rc--animated', on);
      steps.forEach((step) => {
        step.classList.remove('is-reached', 'is-done', 'is-leading');
        step.style.removeProperty('--fill');
      });
      if (!on) return;
      const arrow = desktop.matches && root.querySelector('.steps-rc__list--arrow');
      root.segments = arrow ? steps.length : steps.length - 1;
      root.prefilled = Math.min(Number(root.dataset.prefilled) || 0, root.segments);
    };

    const mark = (steps, fills, reached) => {
      const leading = fills.reduce((last, fill, i) => (fill > 0 ? i : last), -1);
      steps.forEach((step, i) => {
        step.style.setProperty('--fill', fills[i].toFixed(4));
        step.classList.toggle('is-done', fills[i] >= 1);
        step.classList.toggle('is-leading', i === leading);
        step.classList.toggle('is-reached', reached(i));
      });
    };

    const update = (root) => {
      if (!root.classList.contains('steps-rc--animated')) return;
      const steps = [...root.querySelectorAll('.steps-rc__step')];
      const height = window.innerHeight;
      let complete = false;
      if (desktop.matches) {
        const top = root.querySelector('.steps-rc__marker').getBoundingClientRect().top;
        const progress = clamp((height * 0.85 - top) / (height * 0.5));
        const pos = root.prefilled + progress * (root.segments - root.prefilled);
        const fills = steps.map((step, i) => clamp(pos - i));
        mark(steps, fills, (i) => i === 0 || fills[i] > 0 || (i >= root.segments && fills[i - 1] >= 1));
        complete = progress >= 1;
      } else {
        const line = height * 0.6;
        const fills = steps.map((step, i) => {
          const box = step.querySelector('.steps-rc__line').getBoundingClientRect();
          return i < root.prefilled ? 1 : (box.height > 1 ? clamp((line - box.top) / box.height) : 0);
        });
        const last = steps.length - 1;
        const reached = (i) => i === 0 || fills[i] > 0 || (i === last && fills[i - 1] >= 1 && line >= steps[i].querySelector('.steps-rc__dot').getBoundingClientRect().top);
        mark(steps, fills, reached);
        complete = reached(last);
      }
      root.classList.toggle('is-complete', complete);
    };

    const updateAll = () => {
      frame = 0;
      roots.forEach(update);
    };

    const refresh = () => {
      roots = [...document.querySelectorAll('[data-steps-rc]')];
      roots.forEach(layout);
      updateAll();
    };

    window.addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(updateAll);
    }, { passive: true });
    window.addEventListener('resize', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(refresh);
    });
    desktop.addEventListener('change', refresh);
    reduce.addEventListener('change', refresh);
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:unload', () => requestAnimationFrame(refresh));
    refresh();
  })();

  } catch(e) { console.error(e); }
})();
})();
